import React from 'react'
import { Box } from '@material-ui/core'
import { LazyLoadImage } from 'react-lazy-load-image-component'

import DarkLogo from '../../assets/img/logo-black.webp'

const Footer = () => {
  return (
    <Box my={3} textAlign="center">
      <p style={{ marginBottom: '0' }}>Todos los derechos reservados © 2021</p>
      <LazyLoadImage src={DarkLogo} alt="dark-logo" />
    </Box>
  )
}

export default Footer
